import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
  campaignTitle: {
    color: '#242424',
  },
  campaignMsg: {
    color: '#323130',
  },
});
